const QUEUE_KEYS = ['search-link'];

export const dequeueTrackingData = () => {
  if (!window.tracking_data) return;

  try {
    QUEUE_KEYS.forEach((key) => {
      const value = localStorage.getItem(key);
      localStorage.removeItem(key);
      if (value) {
        window.tracking_data[key] = value;
      }
    });
  } catch {
    // localStorage throws in private mode or when storage is disabled
  }
};
